import { render } from "./EditJob.vue?vue&type=template&id=c81c65b8&scoped=true"
import script from "./EditJob.vue?vue&type=script&lang=js"
export * from "./EditJob.vue?vue&type=script&lang=js"

import "./EditJob.vue?vue&type=style&index=0&id=c81c65b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c81c65b8"]])

export default __exports__